// extracted by mini-css-extract-plugin
export default {"modal":"EF9oMIuxNBg056vldboI","modalTitle":"xBhbnmRx9MBl9JKZU940","modalDescription":"rKA4IcEQi9i3RgZssbIi","modalBtns":"qKRDNC5MIoNOnbfRn7Ot"};